import React, { useState } from "react";
import "./styles.less";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/NewTitle";

export const SolutionIndustryValue = (props) => {
  const { t } = useTranslation();
  const { values } = props;
  const [currentSolutionValue, setCurrentSolutionValue] = useState(
    "value-menu-item-one"
  );
  const [element, setElement] = useState(1);
  const onMouseLeave = () => {};
  const nextFun = () => {
    if (element > 3) {
      setElement(1);
    } else {
      setElement(element + 1);
    }
  };
  const lastFun = () => {
    if (element <= 1) {
      setElement(4);
    } else {
      setElement(element - 1);
    }
  };
  const industryValueRender = () => {
    return (
      <div className="solution-industry-value-content">
        <div className="solution-industry-value-menu">
          {values.map((item, index) => {
            return (
              <div
                className="value-menu-item"
                key={index}
                onMouseEnter={() => setCurrentSolutionValue(item.type)}
                onMouseLeave={onMouseLeave}
                // onClick={() => {
                //   setCurrentSolutionValue(item.type);
                // }}
                // mouseenter = {()=>{console.log("het")}}
                
              >
                <span>{item.title}</span>
                <span>
                  <i className="icon authing-icon authing-arrow-right-s-line"></i>
                </span>
              </div>
            );
          })}
        </div>
        <div className="solution-industry-value-text">
          {values.map((item) => {
            if (currentSolutionValue === item.type) {
              return (
                <>
                  <div className="value-text-title">{item.title}</div>
                  <div className="value-text-context">{item.descript}</div>
                </>
              );
            } else {
              return null;
            }
          })}
        </div>
      </div>
    );
  };

  const industryValueMobileRender = () => {
    return (
      <div className="solution-industry-value-mobile">
        <div
          className="last-button"
          onClick={() => {
            lastFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(-90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
        {values.map((item, index) => {
          if (element === index + 1) {
            return (
              <>
                <div className="value-text-title">{item.title}</div>
                <div className="value-text-context">{item.descript}</div>
              </>
            );
          } else {
            return null;
          }
        })}
        <div
          className="next-button"
          onClick={() => {
            nextFun();
          }}
        >
          <i
            className="icon authing-icon authing-arrow-down-line"
            style={{
              transform: "rotate(90deg)",
              display: "inline-block",
            }}
          ></i>
        </div>
      </div>
    );
  };
  return (
    <section className="solution-industry-value">
      <div className="inner">
        <Title title={t("solution.detail.title-value")} align="left" />
        {industryValueRender()}
        {industryValueMobileRender()}
      </div>
    </section>
  );
};
